export default "__VITE_ASSET__CXKvfvOi__"